import React from 'react';

import { Divider, Image, Typography } from 'antd';

import Slot from 'common/components/slot/Slot';
import GridStyleLayout from 'common/components/layout/GridStyleLayout';

import DownloadFolderMetadata from './DownloadFolderMetadata';
import { getImageFolder } from 'pages/folders/folder-details/utils';

import { useFolderDownloadSettingQuery } from 'hooks/folders/queries';

const { Title, Text } = Typography;

const DownloadFolderLayout = (props) => {
  const { children, folderId } = props;

  const { data: latestDownloadSetting } = useFolderDownloadSettingQuery({
    folderId,
    enabled: false,
  });

  const layoutAreas = [
    ['icon', 'name', 'v-divider', 'step'],
    ['icon', 'items', 'v-divider', 'step'],
    ['blank', 'blank', 'v-divider', 'h-divider'],
    ['meta', 'meta', 'v-divider', 'settings'],
  ];

  return (
    <GridStyleLayout
      className='download-folder'
      areas={layoutAreas}
      rows='auto auto auto 1fr'
      columns='60px 250px auto 1fr'
      gap={8}
    >
      <Image
        layoutArea='icon'
        src={getImageFolder(latestDownloadSetting)}
        width={60}
        preview={false}
      />
      <Title
        layoutArea='name'
        level={5}
        ellipsis={{ rows: 2 }}
        gridItemStyle={{ alignSelf: 'end' }}
        style={{ margin: 0 }}
      >
        {latestDownloadSetting?.folderName}
      </Title>
      <Text layoutArea='items'>{latestDownloadSetting?.items} item(s)</Text>

      <DownloadFolderMetadata layoutArea='meta' folderId={folderId} />

      <Divider
        layoutArea='v-divider'
        type='vertical'
        style={{ height: '100%', margin: 0 }}
      />

      <Divider
        layoutArea='h-divider'
        style={{ margin: '8px auto', minWidth: '60%', width: '60%' }}
      />

      <Slot name='step' layoutArea='step'>
        {children}
      </Slot>

      <Slot name='settings' layoutArea='settings'>
        {children}
      </Slot>
    </GridStyleLayout>
  );
};

export default DownloadFolderLayout;
